import React, { createContext, useContext, useEffect, useState } from 'react'
import { List, Table } from 'semantic-ui-react'
import styles from './device-view.module.css'
import DeviceActions from './device-actions'
import IntelMsg from '../../ItelMsg'

export const DeviceViewContext = createContext()

const DeviceView = () => {
  const [tableBody, setTableBody] = useState()
  const { setViewDevice, deviceData } = useContext(DeviceViewContext)
  useEffect(() => {
    if (deviceData) {
      setTableBody(buildRows(deviceData))
    }
  }, [deviceData])
  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="deviceDetails" />
      </div>
      <Table definition>
        <Table.Body>{tableBody}</Table.Body>
      </Table>

      <DeviceActions onBackClick={() => setViewDevice(false)} />
    </div>
  )
}

const getDeviceRow = (label, value) => (
  <Table.Row>
    <Table.Cell width={3}>{label}</Table.Cell>
    <Table.Cell>{value}</Table.Cell>
  </Table.Row>
)

const buildRows = (deviceData) => {
  const rows = [{ assetName: 'mmm' }]
  rows.push(
    getDeviceRow(<IntelMsg id="assetName" />, deviceData.device.name) || 'N/A',
  )

  rows.push(
    getDeviceRow(
      <IntelMsg id="description" />,
      findAttrValue(deviceData.attributes, 'description'),
    ),
  )

  rows.push(
    getDeviceRow(
      <IntelMsg id="registrationDate" />,
      `${new Date(deviceData.device.createdTime)}` || 'N/A',
    ),
  )

  rows.push(
    getDeviceRow(
      <IntelMsg id="batteryInstallationDate" />,
      findAttrValue(deviceData.attributes, 'Battery Installation Date'),
    ),
  )

  rows.push(getDeviceRow(<IntelMsg id="group" />, deviceData.group.name))

  rows.push(
    getDeviceRow(
      <IntelMsg id="geoLocation" />,
      findAttrValue(deviceData.attributes, 'GPS'),
    ),
  )
  rows.push(
    getDeviceRow(
      <IntelMsg id="country" />,
      findAttrValue(deviceData.attributes, 'country'),
    ),
  )
  rows.push(
    getDeviceRow(
      <IntelMsg id="city" />,
      findAttrValue(deviceData.attributes, 'city'),
    ),
  )
  rows.push(
    getDeviceRow(
      <IntelMsg id="address" />,
      findAttrValue(deviceData.attributes, 'address'),
    ),
  )
  rows.push(
    getDeviceRow(
      <IntelMsg id="facilityID" />,
      findAttrValue(deviceData.attributes, 'facilityId'),
    ),
  )
  rows.push(
    getDeviceRow(
      <IntelMsg id="warrantyExpirationDate" />,
      findAttrValue(deviceData.attributes, 'Warranty Ex'),
    ),
  )

  if (Object.keys(deviceData.sampling).length !== 0) {
    const totalList = constructList(deviceData.sampling)
    rows.push(
      getDeviceRow(
        <IntelMsg id="sampling" />,
        <List as="ol">{totalList}</List>,
      ),
    )
  }

  return rows
}

const constructList = (object) => {
  const totalList = []
  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const key in object) {
    const subList = []
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const subKey in object[key]) {
      subList.push(
        <List.Item as="ol" value="-">
          {camelCaseToSentence(subKey)} : {object[key][subKey]}
        </List.Item>,
      )
    }
    const head = (
      <List.Item as="li" value="*">
        <strong>{camelCaseToSentence(key)}</strong>
        {subList}
      </List.Item>
    )
    totalList.push(head)
  }
  return totalList
}
const camelCaseToSentence = (text) => {
  const result = text.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1)
}
const findAttrValue = (list, attrName) => {
  const values = list.find((attrList) => attrList.id.attributeKey === attrName)
  return (
    (values && values.strValue) ||
    (values && values.longValue) ||
    (values && values.doubleValue) ||
    (values && values.booleanValue) ||
    'N/A'
  )
}
export default DeviceView
